import React from 'react'
import { toCsString } from '../utils/string'
import { round } from '../utils/number'

class NumberInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      strValue: toCsString(this.props.value),
      own: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleMouseWheel = this.handleMouseWheel.bind(this)
  }

   UNSAFE_componentWillReceiveProps (nextProps) {
    const { strValue, own } = this.state
    const patt1 = new RegExp(',0+$')
    const patt2 = new RegExp(',[0-9]+0+$')
    if (!own || (!strValue.endsWith(',') && !patt1.test(strValue) && !patt2.test(strValue))) {
      this.setState({
        strValue: round(nextProps.value, 12).toString().replace('.', ',')
      })
    }
    this.setState({
      own: false
    })
    if (nextProps.active) {
      setTimeout(() => {
        this.field.focus()
      }, 100)
    }
  }

  handleKeyPress (e) {
    const patt = new RegExp('[0-9,]')
    if (!patt.test(e.key) || (e.key === ',' && this.state.strValue.includes(','))) {
      e.preventDefault()
    }
  }

  handleChange (e) {
    console.log(1)
    const str = e.target.value.toString()
    const v = Number(str.replace(',', '.'))
    this.setState({
      strValue: str,
      own: true
    })
    setTimeout(() => { this.props.onChange(v) }, 100)
  }

  handleMouseWheel (e) {
    // if (e.target.className.indexOf('designFlowInput') === -1) {
    //   return
    // }
    // e.preventDefault()
    let clearValue = this.state.strValue.replace(',', '.')
    clearValue = clearValue.replace(' ', '')
    let v = Number(clearValue)
    if (v < 1 && e.deltaY > 0) { return }
    v = e.deltaY > 0 ? v - 1 : v + 1
    this.props.onChange(v)
  }

  render () {
    return (
      <input ref={(s) => { this.field = s }} type='text' value={this.state.strValue} onKeyPress={this.handleKeyPress}
        disabled={this.props.disabled} onChange={this.handleChange} onWheel={this.handleMouseWheel}
        className={this.props.className} /* style={{touchAction: 'none'}} */ />
    )
  }
}

// NumberInput.propTypes = {
//   value: PropTypes.number,
//   disabled: PropTypes.bool,
//   active: PropTypes.bool,
//   onChange: PropTypes.func,
//   className: PropTypes.string
// }

export default NumberInput
